<template lang="pug">
.page-smart-control
  .page-header
    IQToolMiddlePaneHeader.header(:header="$t(`${baseTranslationPath}.title`)"
                           :title="pageTitle"
                           :additionalLabels="additionalLabels"
                           @goToListPage="back"
                           @selectLabel="selectLabel"
                           )
    .edit-button-area(v-if="newSmartControl")
      aiq-button(type="primary" class="edit-button" @click="editRecord") {{ $t('global.edit') }}
  .smart-control-area(v-if="newSmartControl")
    .manage-area(v-if="!showEdit")
      NewSmartControlHeader(:smartControlRecord="smartControlRecord"
                v-if="fileVersion"
                :fileVersion="fileVersion"
                @update-docs = "updateDocs")
      NewStages(:smartControlRecord="smartControlRecord"
                v-if="activeStage"
                :stage="activeStage"
                :isCurrentStage="isCurrrentStage"
                @act="actAction")
      NewComment(:documentId="documentId"
                :selectedStage="selectedStage"
                :groupedComments="groupedComments"
                @deleteComment="deleteComment"
                @addComment="addComment")
    .edit-area(v-else)
      Edit(:smartControlRecord="smartControlRecord"
          @update-doc="updateDocStages"
          :agentsAndTeams="agentsAndTeams"
          :rules="rules"
          v-if="agentsAndTeams.length > 0 && rules.length > 0"
          @remove="removeFromSmartCtrl"
          @close="closeEditModal")

  .old-smart-control-area(v-else)
    SmartControlHeader(
          :smartControlRecord="smartControlRecord"
          v-if="fileVersion"
          :fileVersion="fileVersion"
          @update-docs = "updateDocs"
          @selectLabel="selectLabel"
      )
    Stages(:smartControlRecord="smartControlRecord"
        v-if="smartControlRecord"
        @act="actAction"
        @update-doc="updateDocStages")
    Comments(:comments="comments"
            :documentId="documentId"
            @deleteComment="deleteComment"
            @addComment="addComment")
</template>
<script>
import IQToolMiddlePaneHeader from '@/pages/IQTools/Partials/IQToolMiddlePaneHeader/IQToolMiddlePaneHeader.vue';
import get from 'lodash/get';
import Comments from './children/Comments.vue';
import SmartControlHeader from './children/Header.vue';
import Stages from './children/Stages.vue';
import { mapState } from 'vuex';
import { getLatestVersion } from '../common/util';
import NewSmartControlHeader from './children/HeaderNew.vue';
import NewStages from './children/StagesNew.vue';
import NewComment from './children/CommentNew.vue';
import Edit from './children/Edit.vue';
import EditArea from '@/components/EditArea.vue';
import { AGENT_LIMIT, RULES_LIMIT, TEAM_LIMIT } from '@/constants/pagination';
import toLower from 'lodash/toLower';
import capitalize from 'lodash/capitalize';
import trim from 'lodash/trim';
import groupBy from 'lodash/groupBy';

export default {
  name: 'SmartControlManage',
  components: {
    IQToolMiddlePaneHeader,
    Comments,
    SmartControlHeader,
    Stages,
    NewSmartControlHeader,
    NewStages,
    NewComment,
    Edit,
    EditArea,
  },
  data() {
    return {
      baseTranslationPath: 'settings_tab.admin_tab.smart_control.control_list_manage',
      smartControlRecord: null,
      comments: [],
      fileVersion: null,
      documentId: null,
      additionalLabels: [],
      agentsAndTeams: [],
      isCurrrentStage: false,
      activeStage: null,
      showEdit: false,
      rules: [],
      pageTitle: '',
      selectedStage: null,
      groupedComments: {},
    };
  },
  computed: {
    ...mapState({
      agent: state => state.agent.profile,
      newSmartControl: state => state.featureFlags.FEATURE_FLAGS.NEW_SMART_CONTROL_DESIGN,
    }),
  },
  watch: {
    showEdit(val) {
      if (!val) {
        this.getStagesLabels();
        this.pageTitle = '';
      } else {
        this.pageTitle = `${get(this.smartControlRecord, 'name', '')} (${this.$t('global.edit')})`;
        this.additionalLabels = [];
      }
    },
  },
  async mounted() {
    try {
      await this.init();
      this.getStagesLabels();

      if (!this.newSmartControl) {
        const title = get(this.smartControlRecord, 'name', '');
        const version = get(this.fileVersion, 'label', '');
        this.pageTitle = `${title} ${version}`;

      }
      await this.fetchComments();
      await this.fetchRules();
      await this.getAgentsAndTeams();
    } catch (error) {
      this.$aiq.notify.error(this.$t(`${this.baseTranslationPath}.fetch_failed`));
    }
  },
  methods: {
    selectLabel(label) {
      if (!label.active) return;
      this.getIsCurrentStage(label.label);
      this.selectedStage = label.stage_id;
      this.routeToStage(label.label, false, true);
      this.additionalLabels = this.additionalLabels.map(item => {
        return {
          ...item,
          selected: item.label === label.label,
        };
      });
    },
    async removeFromSmartCtrl() {
      try {
        await this.$store.dispatch('smartControl/deleteSmartControl', this.documentId);
        this.$aiq.notify.success(this.$t(`${this.baseTranslationPath}.removed`));
        this.$router.push({
          path: '/settings/smartdrive/smart_control',
        });
      } catch (error) {
        this.$aiq.notify.error(this.$t(`${this.baseTranslationPath}.remove_failed`));
      }
    },
    async fetchRules() {
      const params = {
        limit: RULES_LIMIT,
      };
      const rules = await this.$store.dispatch('smartControl/getRuleList', [
        params,
        true,
      ]);
      this.rules = get(rules, 'data.models', []);
    },
    async getAgentsAndTeams() {
      const agents = await this.$store.dispatch('agents/getAgentsList', [
        { limit: AGENT_LIMIT },
        true,
      ]);
      const agent_data = get(agents, 'data.models', []);

      const agentSelectable = agent_data.map((agent) => {
        return {
          type: 'agent',
          id: agent.id,
          name: agent.fullName,
          uniqueKey: `agent-${agent.id}`,
        };
      });
      const teams = await this.$store.dispatch('teams/getTeamsList', [
        { limit: TEAM_LIMIT },
      ]);
      const team_data = get(teams, 'data.models', []);
      const teamSelectable = team_data.map((team) => {
        return {
          type: 'team',
          id: team.id,
          name: team.name,
          uniqueKey: `team-${team.id}`,
        };
      });
      this.agentsAndTeams = [...agentSelectable, ...teamSelectable];
    },
    getStagesLabels() {
      if (!this.newSmartControl) return [];
      const stages = get(this.smartControlRecord, 'stages', []);
      const currentStage = get(this.smartControlRecord, 'current_stage');
      let currentIndex;
      //if no current stage, that means we have finished review and are at the last stage
      if (!currentStage) {
        //use the last stage as index
        currentIndex = stages.length - 1;
      } else {
        currentIndex = stages.findIndex(stage => toLower(trim(stage.name)) === toLower(trim(get(currentStage, 'name'))));
        if (currentIndex === -1) {
          currentIndex = 0;
        }
      }
      //map every stage till the current index as active
      this.additionalLabels = stages.map((stage, index) => {
        return {
          label: capitalize(trim(stage.name)),
          active: index <= currentIndex,
          selected: index === currentIndex,
          stage_id: stage.id,
        };
      });
    },
    getIsCurrentStage(name) {
      const currentStage = get(this.smartControlRecord, 'current_stage');
      if (!currentStage) {
        this.isCurrrentStage = false;
        return;
      }
      this.isCurrrentStage = toLower(trim(currentStage.name)) === toLower(trim(name));
    },
    async init() {
      const id = get(this.$route, 'params.id');
      this.documentId = id;
      const response = await this.$store.dispatch('smartControl/getSmartControl', id);
      this.smartControlRecord = get(response, 'data', {});
      const versions = get(this.smartControlRecord, 'versions', []);
      this.fileVersion = getLatestVersion(versions);
      this.routeToStage();
      this.getIsCurrentStage(get(this.activeStage, 'name'));
      this.selectedStage = get(this.activeStage, 'id');
    },

    routeToStage(name, onInit = true, captureClick = false) {
      const currentStage = get(this.smartControlRecord, 'current_stage');
      const stages = get(this.smartControlRecord, 'stages', []);

      if (!currentStage && !captureClick) {
        //make the last stage the active stage
        this.activeStage = stages[stages.length - 1];
        return;
      } else {
        if (onInit) {
          //use the current stage as the active stage
          this.activeStage = stages.find(stage => toLower(trim(stage.name)) === toLower(trim(currentStage.name)));
        } else {
          this.activeStage = stages.find(stage => {
            return toLower(trim(stage.name)) === toLower(trim(name));
          });
        }
      }
    },
    groupCommentsByStage(comments) {
      const first_stage_id = get(this.smartControlRecord, 'stages[0].id');
      const grouped = groupBy(comments, item => {
        return get(item, 'payload.stage_id', first_stage_id);
      });
      return grouped;
    },

    async fetchComments() {
      const response = await this.$store.dispatch('smartControl/fetchComments', { id: this.documentId });
      this.comments = get(response, 'data.models', []);
      this.groupedComments = this.groupCommentsByStage(this.comments);
    },

    async deleteComment(payload) {
      try {
        await this.$store.dispatch('smartControl/deleteComment', payload);
        this.$aiq.notify.success(this.$t(`${this.baseTranslationPath}.comment_deleted`));
        await this.fetchComments();
      } catch (error) {
        this.$aiq.notify.error('Unable to delete comment');
      }
    },
    async addComment(comment) {
      try {
        await this.$store.dispatch('smartControl/addComment', comment);
        this.$aiq.notify.success(this.$t(`${this.baseTranslationPath}.comment_added`));
        await this.fetchComments();
      } catch (error) {
        this.$aiq.notify.error('Unable to add comment');
      }
    },
    back() {
      const currentPath = this.$route.path;
      const parentPath = currentPath.substring(0, currentPath.lastIndexOf('/'));
      // get parant name if exist
      const name = get(this.$route, 'meta.parentName');
      // move to the parent
      this.$router.push(name ? { name } : parentPath);
    },
    async updateDocs(payload) {
      try {
        await this.$store.dispatch('smartControl/createVersion', {
          id: this.documentId,
          data: payload,
        });
        this.$aiq.notify.success('Document updated successfully');
        await this.init();
      } catch (error) {
        const err = get(error, 'response.data.message', 'Unable to update document');
        this.$aiq.notify.error(err);
      }
    },
    editRecord() {
      this.showEdit = true;
    },
    closeEditModal() {
      this.showEdit = false;
    },
    async updateDocStages(payload) {
      const data = {
        id: this.documentId,
        data: payload,
      };
      try {
        await this.$store.dispatch('smartControl/updateSmartControl', data);
        await this.init();
        this.routeToStage();
        this.getStagesLabels();

        this.$aiq.notify.success('Document updated successfully');
      } catch (error) {
        const err = get(error, 'response.data.message', 'Unable to update document');
        this.$aiq.notify.error(err);
      }
    },
    async actAction(data) {
      try {
        await this.$store.dispatch('smartControl/SmartControlAction', {
          id: this.smartControlRecord.id,
          action: data.action,
          reason: data.reason,
          stage_id: this.selectedStage ? this.selectedStage : get(this.smartControlRecord, 'current_stage.id'), // if stage is not selected, use the current stage id

        });
        this.$aiq.notify.success('Action successful');
        if (data.action === 'reject') {
          await this.init();
          this.getStagesLabels();
          await this.fetchComments();
        } else {
          this.back();
        }
      } catch (error) {
        const err = get(error, 'response.data.message', 'Unable to perform the action');
        this.$aiq.notify.error(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page-smart-control {
    overflow-y: auto;
    height: 100vh;
    padding-top: 20px;
}

.page-header {
    display: flex;
    width:100%;
    justify-content: space-between;
}

:deep(.middle-column-header) {
    width: 95% !important;
}

.edit-button {
  height:40px;
  width:70px;
}

.edit-button-area {
  display: flex;
  justify-content: flex-end;;
}
</style>